module.exports = __webpack_public_path__ + "static/media/C5.7f8d35ad.wav";